<template>
	<div class="incenters">
		<div style>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" :optional="!rowData" :useAutoOptional="false" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')"></Commonbtn>
			<!-- <Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export" :src="require('@/assets/icon/daoc.png')"></Commonbtn> -->
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="ProviderRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum="7" :tableData="tableData" :headerData="headerData" height="100%"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<!-- 操作弹窗  -->
		<DialogFrom width="1000px" :title="EditrTitle" :dialogVisible="dialogVisibleEditr" @cancel="cancelEditr"
			@dialogOK="dialogOKEditr">
			<div v-if="EditrTitle == '新增' || EditrTitle == '修改'">
				<div class="from">
					<template v-for="(item , index) of EditrFrom">
						<Commondropdownlist :key="index" ref="ProductAdd" :radio="item.radio" :options="item.options"
							:widths="item.widths" :btx="item.btx" :inputdata="item.inputdata" :title="item.title"
							:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
							:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
							:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
							:max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
						</Commondropdownlist>
					</template>

					<div class="custom-table">
						<div class="custom-title">
							<span>关联产品</span>
							<!--handAddTable-->
							<Commonbtn backgroundColor="#FFF" title="新增数据" fontSize="14px" @btnclick="handAddTable"
								:src="require('@/assets/icon/icon-add.png')">
							</Commonbtn>
						</div>
						<el-table :data="dataInfo" style="width: 100%;" height="300">
							<el-table-column prop="InvAddCode" label="商品代码" />
							<el-table-column prop="InvName" label="商品名称" />
							<el-table-column prop="RegistrationNo" label="注册证号" />
							<el-table-column width="120" label="可供业务勾选">
								<template slot-scope="scope">
									<el-checkbox v-model="scope.row.CanChooseBySaler" />
								</template>
							</el-table-column>
							<el-table-column width="150" label="分组编号">
								<template slot-scope="scope">
									<input type="text" v-model="scope.row.GroupCode" class="cell-input" />
								</template>
							</el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<span class="del-btn" @click="handDelTable(scope.$index)">删除</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</DialogFrom>

		<!-- 操作弹窗  -->
		<DialogFrom width="1000px" title="新增数据" :dialogVisible="dialogVisibleAdd" :OKASCAN="false" @cancel="cancelAdd">
			<div class="from">
				<template v-for="(item , index) of AddForm">
					<Commondropdownlist :key="index" ref="FormAdd" :radio="item.radio" :options="item.options"
						:widths="item.widths" :btx="item.btx" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
					</Commondropdownlist>
				</template>

				<div class="custom-table">
					<div class="custom-title">
						<Commonbtn style="margin: 0px;" backgroundColor="#FFF" title="选择" fontSize="14px"
							@btnclick="cancelAdd" :src="require('@/assets/icon/icon-add.png')"></Commonbtn>
					</div>
					<el-table :data="tableDataInfo" style="width: 100%;" height="300"
						@selection-change="handSelectTion">
						<el-table-column type="selection" width="55" />
						<el-table-column prop="InvAddCode" label="商品代码" />
						<el-table-column prop="InvName" label="商品名称" />
						<el-table-column prop="RegistrationNo" label="注册证号" />
					</el-table>
				</div>
			</div>
		</DialogFrom>

		<!-- 询问弹窗    -->
		<Dialog width="420px" :title="titieTI" :dialogVisible="dialogVisibleTI" @cancel="cancelTI"
			@dialogOK="dialogOKTI" :src="srcTI">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">{{contextTI}}</span>
		</Dialog>
		<!--多选问题弹窗-->
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum="100" :tableData="tableDatadrjg"
					height="100%"></Commontable>
			</div>
		</DialogFrom>
		<Commonpictureswitching :show="show" @hidefn="hidefn" :picImages="picImages"></Commonpictureswitching>
		<Prviwe :show="shows" @hidefn="hidefns" :imgsrc="imgsrc"></Prviwe>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Prviwe from "../../../../components/picturepreview.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import FilesAndPictures from "@/components/FilesAndPictures.vue";
	import EditrFrom from "../fromData/EditrFrom";
	import Dialog from "../../../../components/dialog.vue";
	import Commondown from "../../../../components/common-down.vue";
	import CommonbtnUpLoad from "../../../../components/common-upload.vue";
	import Commonpictureswitching from "../../../../components/common-pictureswitching.vue";
	import CommonUploadEnclosure from "../../../../components/common-upload-Enclosure.vue";
	import headerData from '../headerData/headerData'
	import utils from '@/common/utils'
	import {
		ProductAdd,
		ProductInfo,
		ProductEdit,
		ProductDelete,
		CusType
	} from "@/api/home";

	import {
		GetInventoryList
	} from "@/api/newsapi";


	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad,
			Commonpictureswitching,
			CommonUploadEnclosure,
			Prviwe,
			FilesAndPictures
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				dialogVisibleEditr: false,
				dialogVisibleTI: false,
				dialogVisiblesdrjg: false,
				rightboo: false,
				loading: false,
				show: false,
				shows: false,
				loadingTableprocess: true,
				srcTI: require('@/assets/icon/icon-errors.png'),
				title: "结果",
				ID: "",
				imgsrc: "",
				contextTI: "",
				EditrTitle: "加载中...",
				titieTI: "加载中...",
				rowData: null,
				handleList: [],
				EditrFrom: [],
				tableDatadrjg: [],
				SMSProviderUploadData: [],
				headerData: [],
				picImages: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false,
					approval: false
				},
				dialogVisibleAdd: false,
				AddForm: [],
				dataInfo: [],
				tableDataInfo: [],
			};
		},
		created() {},
		mounted() {
			let edParams = JSON.parse(JSON.stringify(EditrFrom));
			this.EditrFrom = JSON.parse(JSON.stringify(EditrFrom));
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.AddForm = edParams;
			this.AddForm.splice(4, 3);
		},
		methods: {
			handSelectTion(e) {
				this.dataInfo = JSON.parse(JSON.stringify(this.$utils.filterObj([...new Set([...this.dataInfo, ...e])],
					"InvCode")));
			},
			handAddTable() {
				if (!this.$refs.ProductAdd[0].modelvalue) {
					this.$message.warning('未选择产品线')
					return;
				}
				if (!this.$refs.ProductAdd[1].modelvalue) {
					this.$message.warning('未选择生产厂商')
					return;
				}
				if (!this.$refs.ProductAdd[2].modelvalue) {
					this.$message.warning('未填写产品名称')
					return;
				}
				if (!this.$refs.ProductAdd[3].modelvalue) {
					this.$message.warning('未填写注册证号')
					return;
				}

				this.AddForm[0].disabled = true;
				this.AddForm[1].disabled = true;
				// this.AddForm[2].disabled = true;
				// this.AddForm[3].disabled = true;

				this.dialogVisibleAdd = true;
				this.$nextTick(() => {
					this.$refs.FormAdd[0].modelvalue = this.$refs.ProductAdd[0].modelvalue;
					this.$refs.FormAdd[1].modelvalue = this.$refs.ProductAdd[1].modelvalue;
					this.$refs.FormAdd[2].modelvalue = this.$refs.ProductAdd[2].modelvalue;
					this.$refs.FormAdd[3].modelvalue = this.$refs.ProductAdd[3].modelvalue;
					this.getInventory();
				})
			},
			async getInventory() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await GetInventoryList({
					InvClass: this.$refs.FormAdd[0].modelvalue,
					MFCode: this.$refs.FormAdd[1].modelvalue,
					InvName: this.$refs.FormAdd[2].modelvalue,
					RegistrationNo: this.$refs.FormAdd[3].modelvalue
				})
				if (code == 0) {
					this.tableDataInfo = data.data.map(it => {
						it.CanChooseBySaler = true;
						return it;
					})
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			handDelTable(i) {
				this.dataInfo.splice(i, 1);
			},
			// 新增
			async ProductAdd() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let lstInventory = [];
				this.dataInfo.forEach(it => {
					lstInventory.push({
						invCode: it.InvCode,
						GroupCode: it.GroupCode,
						CanChooseBySaler: it.CanChooseBySaler ? 1 : 0
					})
				})
				let {
					code,
					message
				} = await ProductAdd({
					InvClass: this.$refs.ProductAdd[0].modelvalue,
					MFCode: this.$refs.ProductAdd[1].modelvalue,
					InvName: this.$refs.ProductAdd[2].modelvalue,
					RegistrationNo: this.$refs.ProductAdd[3].modelvalue,
					ShowName: this.$refs.ProductAdd[4].modelvalue,
					InvType: this.$refs.ProductAdd[5].modelvalue,
					ShowNameForCombo: this.$refs.ProductAdd[7].modelvalue,
					lstInventory: lstInventory,
					MarkupRate: utils.KeepDecimalPoint(this.$refs.ProductAdd[6].CommModelvalue, 1)
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleEditr = false
					this.$parent.ProductList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			add() {
				this.dataInfo = [];
				this.EditrTitle = '新增';
				this.dialogVisibleEditr = true
			},
			// 详情
			async ProductInfo() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await ProductInfo({
					PDCode: this.rowData.PDCode
				})
				if (code == 0) {
					this.dialogVisibleEditr = true
					this.$nextTick(() => {
						this.$refs.ProductAdd[0].modelvalue = data.InvClass
						this.$refs.ProductAdd[1].modelvalue = data.MFCode
						this.$refs.ProductAdd[2].modelvalue = data.InvName
						this.$refs.ProductAdd[3].modelvalue = data.RegistrationNo
						this.$refs.ProductAdd[4].modelvalue = data.ShowName
						this.$refs.ProductAdd[5].modelvalue = data.InvType
						this.$refs.ProductAdd[7].modelvalue = data.ShowNameForCombo
						this.dataInfo = data.lstInventory.map(it => {
							it.CanChooseBySaler = it.CanChooseBySaler === 1 ? true : false;
							return it;
						});
						this.$refs.ProductAdd[6].CommModelvalue = data.MarkupRate
					})
				} else {
					this.$message.warning(message)
				}
				loading.close();
			},
			// 修改
			async ProductEdit() {
				let lstInventory = [];
				this.dataInfo.forEach(it => {
					lstInventory.push({
						invCode: it.InvCode,
						GroupCode: it.GroupCode,
						CanChooseBySaler: it.CanChooseBySaler ? 1 : 0
					})
				})
				let {
					code,
					message
				} = await ProductEdit({
					PDCode: this.rowData.PDCode,
					InvClass: this.$refs.ProductAdd[0].modelvalue,
					MFCode: this.$refs.ProductAdd[1].modelvalue,
					InvName: this.$refs.ProductAdd[2].modelvalue,
					RegistrationNo: this.$refs.ProductAdd[3].modelvalue,
					ShowName: this.$refs.ProductAdd[4].modelvalue,
					InvType: this.$refs.ProductAdd[5].modelvalue,
					ShowNameForCombo: this.$refs.ProductAdd[7].modelvalue,
					lstInventory: lstInventory,
					MarkupRate: utils.KeepDecimalPoint(this.$refs.ProductAdd[6].CommModelvalue, 1)
				})

				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleEditr = false
					this.$parent.ProductList()
				} else {
					this.$message.warning(message)
				}
			},
			update() {
				if (this.rowData) {
					this.EditrTitle = '修改';
					this.ProductInfo();
					return
				}
				this.$message.warning('请选择您要操作的数据！')
			},
			// 删除
			async ProductDelete() {
				let {
					code,
					message
				} = await ProductDelete({
					PDCode: this.rowData.PDCode
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleTI = false
					this.$parent.ProductList()
				} else {
					this.$message.warning(message)
				}
			},
			del() {
				if (this.rowData) {
					this.titieTI = '删除提示信息';
					this.dialogVisibleTI = true;
					this.contextTI = '确认要删除该条数据吗？';
					this.srcTI = require('@/assets/icon/icon-del2.png');
					return
				}
				this.$message.warning('请选择您要操作的数据！')
			},
			Export() {},
			hidefn() {
				this.show = false
			},
			hidefns() {
				this.shows = false
			},
			Look(par) {
				if (
					par.Extension == "jpg" ||
					par.Extension == "png" ||
					par.Extension == "gif"
				) {
					this.shows = true;
					this.imgsrc = par.ImageUrl;
				} else if (par.Extension == "pdf") {
					window.open(par.FilePath, "_blank");
				} else {
					window.location.href = par.ImageUrl;
				}
			},
			Del(fileAddImgData, index) {
				this.SMSProviderUploadData.splice(index, 1);
			},
			onRowClick(val) {
				this.rowData = val
			},
			handleCurrentChange(pageindex) {
				this.$emit("handleCurrentChange", pageindex);
			},
			handleSizeChange(paegSzie) {
				this.$emit("handleSizeChange", paegSzie);
			},
			handleSelectionChange(val) {
				this.handleList = val;
			},
			cancelTI() {
				this.dialogVisibleTI = false;
			},
			dialogOKTI() {
				if (this.titieTI == '删除提示信息') {
					this.ProductDelete()
				}
			},
			cancelEditr() {
				this.dialogVisibleEditr = false;
			},
			dialogOKEditr() {
				if (this.EditrTitle == '新增') {
					this.ProductAdd()
				} else if (this.EditrTitle == '修改') {
					this.ProductEdit()
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false;
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false;
			},
			cancelAdd() {
				this.dialogVisibleAdd = false;
			},
			dialogOKAdd() {

			}
		},
		watch: {
			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"));
					data.Menus.forEach((item, index) => {
						if (item.NodeID == 9) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, indexes) => {
										if (itemes.NodeID == to.query.MenuID) {
											this.qus = itemes.Nodes;
										}
									});
								}
							});
						}
					});
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == "add") {
								this.qx.add = true;
							} else if (item.NodeName == "edit") {
								this.qx.update = true;
							} else if (item.NodeName == "delete") {
								this.qx.del = true;
							} else if (item.NodeName == "stopif") {
								this.qx.del = true;
							} else if (item.NodeName == "assignment") {
								this.qx.assignment = true;
							} else if (item.NodeName == "enabled") {
								this.qx.enabled = true;
							} else if (item.NodeName == "skip") {
								this.qx.skip = true;
							} else if (item.NodeName == "reset") {
								this.qx.reset = true;
							} else if (item.NodeName == "setting") {
								this.qx.setting = true;
							} else if (item.NodeName == "submit") {
								this.qx.submit = true;
							} else if (item.NodeName == "approval") {
								this.qx.approval = true;
							}
						});
					}
				},
				deep: true,
				immediate: true
			},
			dialogVisibleEditr: {
				handler(newDialogEditr, oldDialogEditr) {
					if (!newDialogEditr) {
						this.$refs.ProductAdd.forEach((v, i) => {
							if (i == 6) {
								v.CommModelvalue = undefined
							}
							v.modelvalue = ''
						})
					}
				}
			},
			dialogVisibleTI: {
				handler(newDialogTI, oldDialogTI) {
					if (!newDialogTI) {
						this.titieTI = '加载中...';
						this.contextTI = '加载中...';
						this.srcTI = require('@/assets/icon/icon-del2.png');
					}
				}
			},
		}
	};
</script>

<style lang="less" scoped>
	.FilesAndPictures {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		// outline: 1px solid red;
	}

	.custom-table {
		padding: 12px;

		.custom-title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 16px;
			font-weight: 500;
			padding: 12px 0px;
		}


		.cell-input {
			width: 100%;
			height: 100%;
			border: 0;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			padding-left: 10px;
			padding-right: 10px;
			box-sizing: border-box;
			color: #606266;

			&:focus {
				border: 1px solid rgb(231 29 67);
				color: rgb(231 29 67);
				background: #fff;
			}
		}

		/deep/.el-table .el-table__cell {
			padding: 8px 0;

			.cell {
				.update_ipt {
					.el-input__inner {
						height: 28px;
						line-height: 28px;
						border-radius: 0px;
					}

					.el-input__inner:focus {
						border-color: #e71d43;
					}
				}

				.del-btn {
					color: #e71d43;
					cursor: pointer;
				}

				.el-checkbox__input.is-checked .el-checkbox__inner,
				.el-checkbox__input.is-indeterminate .el-checkbox__inner {
					background-color: #e71d43;
					border-color: #e71d43;
				}
			}
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}

	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }

		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.imgBJ {
		width: 120px;
		height: 120px;
		position: relative;
		// top: 38px;
		margin-left: 20px;
		border: 1px solid #c1c5ca;
	}

	.uploadImg {
		// width: 800px;
		// border: 1px solid red;
		display: inline-block;
		vertical-align: top;
		margin-left: -35px;
		margin-top: 13px;
	}

	.DelOrSee {
		width: 120px;
		height: 120px;
		display: inline-block;
		background-color: #000;
		opacity: 0.2;
		position: relative;
		margin-left: -120px;
	}

	.del_icon {
		position: relative;
		left: 80px;
		top: -50px;
		z-index: 99;
		cursor: pointer;
	}

	.See_icon {
		position: relative;
		left: 87px;
		top: -54px;
		z-index: 99;
		cursor: pointer;
	}

	.SeeBtn {
		margin: 0 auto;
		width: 500px;
		// border: 1px solid;
		display: flex;
		justify-content: space-around;
	}
</style>
